import Cookies from "js-cookie";

const TokenKey = "JH-Token";

function getToken() {
  return Cookies.get(TokenKey);
}
//token在Cookie中存储的天数，默认7天
function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 });
}

function removeToken() {
  return Cookies.remove(TokenKey);
}
/**
 * 设置SessionStorage
 */
export function setSession(key, value) {
  sessionStorage.setItem(key, value);
}
/**
 * 获取SessionStorage
 */
export function getSession(key) {
  return sessionStorage.getItem(key);
}
/**
 * 移除SessionStorage
 */
export function removeSession(key) {
  return sessionStorage.removeItem(key);
}
export default {
  getToken,
  setToken,
  removeToken,
  setSession,
  getSession,
  removeSession,
};
